import React from 'react';
import Spe from '../assets/spe.png';
const SpecialOffer = () => {
    return (
        <div className='py-11'>
            <div className="container">
                <div className="cta-img">
                    <img src={Spe} alt="" srcset="" />
                </div>
            </div>
        </div>
    );
};

export default SpecialOffer;